module.exports = __webpack_public_path__ + "assets/img/home-tab-active.c7048610.png";